import React from 'react';
import API from '../../utils/API';
import 'react-datetime/css/react-datetime.css';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import ToggleField from '../../components/inputs/toggleField';
import LocationLookup from '../../components/inputs/locationLookup';
import FieldModal from '../../components/modals/fieldModal';

class AddEventModal extends React.Component {
    constructor(props) {
        super(props);

        this.contactSearchTimeouts = {};
        this.accountSearchTimeouts = {};

        const eventBranding = {
            accentColor: props.organization.branding.accentColor,
            fontColor: props.organization.branding.fontColor,
            backgroundColor: props.organization.branding.backgroundColor,
            logo: { name: "Organization Logo", preview: props.organization.branding.logo },
        };

        const salesforceIntegration = props.organization.integrations.find(
            (integration) => integration.identifier === 'salesforce'
        );
        let sfRegStatus = 'Registered';
        let sfCheckinStatus = 'Checked In';
        let sfNotAttendingStatus = 'Did Not Attend';
        let customFields = [];
        if (salesforceIntegration) {
            salesforceIntegration.requiredFields.forEach((field) => {
                if (field.id === 'registeredStatus') sfRegStatus = field.value;
                if (field.id === 'checkedinStatus') sfCheckinStatus = field.value;
                if (field.id === 'didNotAttendStatus') sfNotAttendingStatus = field.value;
            });
            customFields = salesforceIntegration.customFields || [];
        }

        let sfCredentials = {};
        let sfToken = '';
        if (salesforceIntegration && salesforceIntegration.credentials) {
            sfCredentials = salesforceIntegration.credentials;
            sfToken = sfCredentials.token || '';
        }

        this.state = {
            event: {
                experienceType: 'hybrid',
                name: '',
                startDate: moment().format('MM/DD/YYYY'),
                endTime: '5:00 PM',
                startTime: '8:00 AM',
                endDate: moment().format('MM/DD/YYYY'),
                timezone: '',
                expectedNumberOfAttendees: '',
                allowPublicRegistrations: false
            },
            cityLookup: '',
            requiredFields: {
                name: false,
                startDate: false,
                endDate: false,
                timezone: false,
                expectedNumberOfAttendees: false,
            },
            selectedVenue: null,
            eventBranding: eventBranding,
            submitting: false,
            salesforceEnabled: salesforceIntegration ? salesforceIntegration.enabled : false,
            salesforceToggled: salesforceIntegration ? salesforceIntegration.enabled : false,
            salesforceCampaign: '',
            salesforceRegistrationStatus: sfRegStatus,
            salesforceCheckedinStatus: sfCheckinStatus,
            salesforceNotAttendingStatus: sfNotAttendingStatus,
            isConflictsEventName: false,
            formIsValid: false,
            salesforceCampaignErrorTrigger: false,
            customFields: customFields,
            // Salesforce lookup states
            sfCredentials: sfCredentials,
            sfToken: sfToken,
            selectedAccount: null,
            accountSearchValues: {},
            accountSearchResults: {},
            accountSearching: {},
            selectedAccounts: {},
            selectedContact: null,
            contactSearchValues: {},
            contactSearchResults: {},
            contactSearching: {},
            selectedContacts: {},
            visibleSfContactSearches: 1,
        };
    }

    validateForm = () => {
        const { event, requiredFields, salesforceToggled, salesforceCampaign, customFields } = this.state;

        let formIsValid = true;

        // Check required fields
        Object.keys(requiredFields).forEach((key) => {
            if (!event[key] || event[key] === '') {
                formIsValid = false;
            }
        });

        // Ensure expectedNumberOfAttendees is a number greater than 0
        const attendees = Number(event.expectedNumberOfAttendees);
        if (isNaN(attendees) || attendees <= 0) {
            formIsValid = false;
        }

        // Check salesforce fields if toggled
        if (salesforceToggled && (!salesforceCampaign || salesforceCampaign === '')) {
            formIsValid = false;
        }

        // Check required custom fields
        if (salesforceToggled && customFields) {
            customFields.forEach((field) => {
                if (field.required && (!field.value || field.value === '')) {
                    formIsValid = false;
                }
            });
        }

        this.setState({ formIsValid });
    }

    validateEventName = async (value) => {
        if (!value || value.trim() === '') {
            this.setState({ isConflictsEventName: false }, this.validateForm);
            return;
        }

        const valueWithoutSpaces = value.replace(/\s+/g, '');
        try {
            const orgId = this.props.organization._id;
            const response = await API().post(`Organizations/${orgId}/reservePath`, {
                name: valueWithoutSpaces.toLowerCase()
            });

            this.setState({
                isConflictsEventName: response.data === true,
            }, this.validateForm);
        } catch (error) {
            console.error("Error validating path:", error);
            this.setState({
                isConflictsEventName: true,
            }, this.validateForm);
        }
    }

    refreshToken = async () => {
        try {
            const orgId = this.props.organization._id;
            const response = await API().get(`Organizations/${orgId}/integrate/salesforce/refreshAdmin`);
            if (response.data && response.data.token) {
                this.setState({ sfToken: response.data.token });
                return response.data.token;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
        }
        return null;
    }

    searchAccounts = async (value, fieldIndex) => {
        const { sfCredentials, sfToken } = this.state;
        const instanceUrl = sfCredentials.instance_url;
        if (!instanceUrl || !sfToken) return;
        this.setState(prevState => ({
            accountSearching: {
                ...prevState.accountSearching,
                [fieldIndex]: true
            }
        }));

        try {
            const response = await fetch(`${instanceUrl}/services/data/v59.0/parameterizedSearch/?q=${value}&sobject=Account&Account.fields=AccountNumber,Name,BillingCity,BillingState,BillingPostalCode&Account.limit=100`, {
                headers: {
                    'Authorization': `Bearer ${sfToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401) {
                const newToken = await this.refreshToken();
                if (newToken) {
                    return this.searchAccounts(value, fieldIndex);
                }
                return;
            }

            if (response.ok) {
                const data = await response.json();
                this.setState(prevState => ({
                    accountSearchResults: {
                        ...prevState.accountSearchResults,
                        [fieldIndex]: data.searchRecords || []
                    },
                    accountSearching: {
                        ...prevState.accountSearching,
                        [fieldIndex]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    accountSearching: {
                        ...prevState.accountSearching,
                        [fieldIndex]: false
                    }
                }));
            }
        } catch (error) {
            console.error('Error searching accounts:', error);
            this.setState(prevState => ({
                accountSearching: {
                    ...prevState.accountSearching,
                    [fieldIndex]: false
                }
            }));
        }
    }

    triggerAccountSearch = (value, fieldIndex) => {
        if (this.accountSearchTimeouts[fieldIndex]) {
            clearTimeout(this.accountSearchTimeouts[fieldIndex]);
        }
        this.setState(prevState => ({
            accountSearchValues: {
                ...prevState.accountSearchValues,
                [fieldIndex]: value
            }
        }));

        if (value.length === 0) {
            this.setState(prevState => ({
                accountSearchResults: {
                    ...prevState.accountSearchResults,
                    [fieldIndex]: []
                }
            }));
            return;
        }

        if (value.length < 3) return;

        this.accountSearchTimeouts[fieldIndex] = setTimeout(() => {
            this.searchAccounts(value, fieldIndex);
        }, 500);
    }

    selectAccount = (account, fieldIndex) => {
        this.setState(prevState => ({
            selectedAccounts: {
                ...prevState.selectedAccounts,
                [fieldIndex]: account
            },
            accountSearchResults: {
                ...prevState.accountSearchResults,
                [fieldIndex]: []
            },
            accountSearchValues: {
                ...prevState.accountSearchValues,
                [fieldIndex]: account.Name
            }
        }));
    }



    searchContacts = async (value, fieldIndex) => {
        const { sfCredentials, sfToken } = this.state;
        const instanceUrl = sfCredentials.instance_url;

        if (!instanceUrl || !sfToken) return;

        this.setState(prevState => ({
            contactSearching: {
                ...prevState.contactSearching,
                [fieldIndex]: true
            }
        }));

        try {
            const response = await fetch(`${instanceUrl}/services/data/v59.0/parameterizedSearch/?q=${value}&sobject=Contact&Contact.fields=id,Email,FirstName,LastName,MailingAddress,MailingCity,MailingState,MailingPostalCode&Contact.limit=100`, {
                headers: {
                    'Authorization': `Bearer ${sfToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401) {
                const newToken = await this.refreshToken();
                if (newToken) {
                    return this.searchContacts(value, fieldIndex);
                }
                return;
            }

            if (response.ok) {
                const data = await response.json();
                this.setState(prevState => ({
                    contactSearchResults: {
                        ...prevState.contactSearchResults,
                        [fieldIndex]: data.searchRecords || []
                    },
                    contactSearching: {
                        ...prevState.contactSearching,
                        [fieldIndex]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    contactSearching: {
                        ...prevState.contactSearching,
                        [fieldIndex]: false
                    }
                }));
            }
        } catch (error) {
            console.error('Error searching contacts:', error);
            this.setState(prevState => ({
                contactSearching: {
                    ...prevState.contactSearching,
                    [fieldIndex]: false
                }
            }));
        }
    }

    triggerContactSearch = (value, fieldIndex) => {
        if (this.contactSearchTimeouts[fieldIndex]) {
            clearTimeout(this.contactSearchTimeouts[fieldIndex]);
        }
        this.setState(prevState => ({
            contactSearchValues: {
                ...prevState.contactSearchValues,
                [fieldIndex]: value
            }
        }));

        if (value.length === 0) {
            this.setState(prevState => ({
                contactSearchResults: {
                    ...prevState.contactSearchResults,
                    [fieldIndex]: []
                }
            }));
            return;
        }

        if (value.length < 3) return;

        this.contactSearchTimeouts[fieldIndex] = setTimeout(() => {
            this.searchContacts(value, fieldIndex);
        }, 300);
    }

    selectContact = (contact, fieldIndex) => {
        this.setState(prevState => ({
            selectedContacts: {
                ...prevState.selectedContacts,
                [fieldIndex]: contact
            },
            contactSearchResults: {
                ...prevState.contactSearchResults,
                [fieldIndex]: []
            },
            contactSearchValues: {
                ...prevState.contactSearchValues,
                [fieldIndex]: `${contact.FirstName || ''} ${contact.LastName}`.trim()
            }
        }));
    }



    createEvent = () => {
        const { handleSubmit } = this.props;
        const { event, selectedVenue, salesforceToggled, selectedAccount, selectedContact } = this.state;
        // Only add salesforce integrations if toggled
        if (salesforceToggled) {
            /* let updatedSearchValue = [];

            if (selectedAccount) {
                updatedSearchValue.push({
                    id: 'Hospital__c',
                    value: selectedAccount.Name,
                    label: 'Hospital'
                });
            }
            if (selectedContact) {
                updatedSearchValue.push({
                    id: 'Faculty__c',
                    value: `${selectedContact.FirstName || ''} ${selectedContact.LastName}`.trim(),
                    label: 'Faculty'
                });
            }
 */




            event.integrations = {
                salesforce: {
                    campaignName: this.state.salesforceCampaign,
                    registrationStatus: this.state.salesforceRegistrationStatus,
                    checkinStatus: this.state.salesforceCheckedinStatus,
                    notAttendedStatus: this.state.salesforceNotAttendingStatus,
                    customFields: this.state.customFields,
                    accountId: selectedAccount ? selectedAccount.Id : null,
                    contactId: selectedContact ? selectedContact.Id : null,
                }
            };
        }

        this.setState({ submitting: true });
        event.members = [];
        let success = true;
        // Handle venue scenarios
        if (selectedVenue) {
            if (!selectedVenue.platform) {
                success = handleSubmit(event, selectedVenue, false, []);
            } else {
                success = handleSubmit({ ...event, venue: selectedVenue.value }, null, false, []);
            }
        } else {
            success = handleSubmit(event, null, false, []);
        }

        if (!success) {
            this.setState({ submitting: false });
            return;
        }
    };

    componentWillUnmount() {
        Object.values(this.accountSearchTimeouts).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        });
        Object.values(this.contactSearchTimeouts).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        });
    }

    render() {
        const { event, cityLookup, requiredFields, salesforceEnabled, isConflictsEventName, formIsValid, submitting } = this.state;
        const { name, startDate, endDate, timezone, experienceType } = event;
        const { isOpen, toggle } = this.props;
        return (
            <FieldModal
                isOpen={isOpen}
                toggle={toggle}
                size="medium"
                actionButton={this.createEvent}
                actionButtonLabel={submitting ? 'Creating Event...' : 'Create Event'}
                actionButtonDisabled={!formIsValid || isConflictsEventName || submitting || (this.state.salesforceToggled && !this.state.salesforceCampaign)}
                bodyContent={() => {
                    const cityTimezoneOptions = cityLookup !== ''
                        ? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => ({
                            label: `${tz.city}, ${tz.province}`,
                            value: tz.timezone
                        }))
                        : [];

                    return (
                        <div className="sectionBody w-100">
                            <div style={{ textAlign: 'center' }}>
                                <h1>Create New Event</h1>
                                <div className='mb-20 mt-10'>
                                    <p className='mb-10'>Please enter the information below to set up your experience</p>
                                </div>
                            </div>

                            <div className='flex flex-wrap jcc' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 96px)' }}>
                                <div className="sectionBlock mr-15 mb-15" style={{ maxWidth: 600, paddingLeft: 1 }}>
                                    <InputField
                                        label={'Event Name'}
                                        required={true}
                                        errorTrigger={requiredFields.name || isConflictsEventName}
                                        errorMessage={"Event name not supported"}
                                        value={name}
                                        onChange={(e) => {
                                            const updatedEvent = { ...event, name: e.target.value };
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }}
                                        onBlur={(e) => this.validateEventName(e.target.value)}
                                    />

                                    <div className="flex-sb w-100">
                                        <div className="mr-10 w-100">
                                            <InputField
                                                label={'Start Date'}
                                                defaultValue={moment(startDate).format('yyyy-MM-DD')}
                                                min={moment().format('yyyy-MM-DD')}
                                                required={true}
                                                errorTrigger={requiredFields.startDate}
                                                type={'date'}
                                                inputIcon={<i className="lar la-calendar" />}
                                                onChange={(e) => {
                                                    const updatedEvent = {
                                                        ...event,
                                                        startDate: moment(e.target.value).format('MM/DD/YYYY')
                                                    };
                                                    this.setState({ event: updatedEvent }, this.validateForm);
                                                }}
                                            />
                                        </div>

                                        <div className="ml-10 w-100">
                                            <InputField
                                                label={'End Date'}
                                                defaultValue={moment(endDate).format('yyyy-MM-DD')}
                                                min={moment(startDate).format('yyyy-MM-DD')}
                                                required={true}
                                                errorTrigger={requiredFields.endDate}
                                                type={'date'}
                                                inputIcon={<i className="lar la-calendar" />}
                                                onChange={(e) => {
                                                    const updatedEvent = {
                                                        ...event,
                                                        endDate: moment(e.target.value).format('MM/DD/YYYY')
                                                    };
                                                    this.setState({ event: updatedEvent }, this.validateForm);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <ToggleField
                                        label="This will be a virtual only event"
                                        icons={false}
                                        checked={experienceType === 'virtual'}
                                        onChange={(e) => {
                                            const type = e.target.checked ? 'virtual' : 'hybrid';
                                            const updatedEvent = { ...event, experienceType: type };
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }}
                                    />

                                    {(experienceType === 'in-person' || experienceType === 'hybrid') && (
                                        <LocationLookup
                                            selectedPlace={this.state.selectedVenue}
                                            locations={this.props.locations}
                                            label="Location Finder"
                                            placeholder={<p className='grey'><i>Search for the venue where the event will take place</i></p>}
                                            noOptionsMessage="No results"
                                            onSelect={(location) => {
                                                let updatedEvent = { ...event };
                                                if (location.timezone) {
                                                    updatedEvent.timezone = location.timezone;
                                                }
                                                this.setState({
                                                    selectedVenue: location,
                                                    event: updatedEvent
                                                }, this.validateForm);
                                            }}
                                            classes="w-100"
                                        />
                                    )}

                                    <SelectField
                                        label={'Timezone'}
                                        value={timezone ? {
                                            value: timezone,
                                            label: <p>
                                                {timezone}
                                                <span className='grey'><i>{` (${moment().tz(timezone).zoneAbbr()})`}</i></span>
                                            </p>
                                        } : null}
                                        placeholder="Search for nearest city"
                                        name="timezones"
                                        classes="w-100"
                                        options={cityTimezoneOptions}
                                        required={true}
                                        errorTrigger={requiredFields.timezone}
                                        onInputChange={(text) => this.setState({ cityLookup: text })}
                                        noOptionsMessage={({ inputValue }) =>
                                            !inputValue ? 'Type city name to get options' : 'No cities match your search'}
                                        onChange={(timezone) => {
                                            const updatedEvent = { ...event, timezone: timezone.value };
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }}
                                    />

                                    <div className="w-100">
                                        <InputField
                                            label={'How Many Attendees Are You Expecting?'}
                                            value={event.expectedNumberOfAttendees}
                                            min={1}
                                            required={true}
                                            errorTrigger={requiredFields.expectedNumberOfAttendees}
                                            errorMessage={"Must be greater than 0"}
                                            type={'number'}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Don't allow negative values
                                                if (value.includes('-')) return;

                                                const updatedEvent = {
                                                    ...event,
                                                    expectedNumberOfAttendees: value
                                                };
                                                this.setState({ event: updatedEvent }, this.validateForm);
                                            }}
                                        />
                                    </div>

                                    {salesforceEnabled && (
                                        <div>
                                            <h3 className='blockHeader'>Salesforce</h3>
                                            <p className='small gray mb-10'>Connect to Salesforce to sync attendee data and create new leads.</p>

                                            <ToggleField
                                                icons={false}
                                                label="Enable Salesforce Integration"
                                                checked={this.state.salesforceToggled}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    this.setState({
                                                        salesforceToggled: checked,
                                                        salesforceCampaign: checked ? this.state.salesforceCampaign : ''
                                                    }, this.validateForm);
                                                }}
                                            />

                                            {this.state.salesforceToggled && (
                                                <div className="w-100">
                                                    <InputField
                                                        label={'Campaign Name'}
                                                        value={this.state.salesforceCampaign}
                                                        placeholder={'Name the Salesforce campaign for this event'}
                                                        required={true}
                                                        errorTrigger={this.state.salesforceCampaignErrorTrigger}
                                                        inputIcon={<i className="lab la-salesforce" />}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceCampaign: e.target.value }, this.validateForm);
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Registration Status'}
                                                        value={this.state.salesforceRegistrationStatus}
                                                        placeholder={'Registered'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceRegistrationStatus: e.target.value }, this.validateForm);
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Checked In Status'}
                                                        value={this.state.salesforceCheckedinStatus}
                                                        placeholder={'Checked In'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceCheckedinStatus: e.target.value }, this.validateForm);
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Did Not Attend Status'}
                                                        value={this.state.salesforceNotAttendingStatus}
                                                        placeholder={'Did Not Attend'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceNotAttendingStatus: e.target.value }, this.validateForm);
                                                        }}
                                                    />





                                                    {this.state.customFields && this.state.customFields.length > 0 && (
                                                        <div className='mt-10'>
                                                            {(() => {
                                                                const sfContactSearchIndices = this.state.customFields.map((field, index) => field.type === 'sfcontactsearch' ? index : -1).filter(idx => idx !== -1);
                                                                const visibleSfContactSearchCount = Math.min(this.state.visibleSfContactSearches || 1, sfContactSearchIndices.length);
                                                                return (
                                                                    <>
                                                                        {this.state.customFields.map((field, index) => {
                                                                            if (field.type === 'select') {
                                                                                let processedOptions = field.options || [];
                                                                                // Handle options that may not have value property (use label as value)
                                                                                processedOptions = processedOptions.map(opt => ({
                                                                                    value: opt.value || opt.label,
                                                                                    label: opt.label
                                                                                }));
                                                                                return (
                                                                                    <SelectField
                                                                                        key={index}
                                                                                        label={field.label || `Field ${index + 1}`}
                                                                                        required={field.required}
                                                                                        value={field.value ? { value: field.value, label: field.options?.find(opt => opt.value === field.value)?.label || field.value } : null}
                                                                                        options={processedOptions}
                                                                                        onChange={(selectedOption) => {
                                                                                            console.log({ selectedOption })
                                                                                            const updatedCustomFields = [...this.state.customFields];
                                                                                            updatedCustomFields[index].value = selectedOption ? selectedOption.value : '';
                                                                                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            } else if (field.type === 'nestedSection') {
                                                                                const selectedOptionLabel = field.options?.find(opt => opt.value === field.value)?.label || field.value;
                                                                                const triggeredFields = field.triggerOptions?.[selectedOptionLabel] || [];
                                                                                let processedOptions = field.options || [];
                                                                                // Handle options that may not have value property (use label as value)
                                                                                processedOptions = processedOptions.map(opt => ({
                                                                                    value: opt.value || opt.label,
                                                                                    label: opt.label
                                                                                }));
                                                                                return (
                                                                                    <div key={index}>
                                                                                        <SelectField
                                                                                            label={field.label || `Field ${index + 1}`}
                                                                                            required={field.required}
                                                                                            value={field.value ? { value: field.value, label: selectedOptionLabel } : null}
                                                                                            options={processedOptions}
                                                                                            onChange={(selectedOption) => {
                                                                                                const updatedCustomFields = [...this.state.customFields];
                                                                                                updatedCustomFields[index].value = selectedOption ? selectedOption.value : '';
                                                                                                // Clear nested values when main selection changes
                                                                                                if (updatedCustomFields[index].nestedValues) {
                                                                                                    updatedCustomFields[index].nestedValues = {};
                                                                                                }
                                                                                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                            }}
                                                                                        />
                                                                                        {field.value && triggeredFields.map((triggerField, triggerIndex) => {
                                                                                            const nestedValue = field.nestedValues?.[triggerField.id] || '';
                                                                                            if (triggerField.type === 'select') {
                                                                                                // Handle options that may not have value property (use label as value)
                                                                                                const processedOptions = (triggerField.options || []).map(opt => ({
                                                                                                    value: opt.value || opt.label,
                                                                                                    label: opt.label
                                                                                                }));
                                                                                                const selectedOption = processedOptions.find(opt => opt.value === nestedValue);

                                                                                                return (
                                                                                                    <SelectField
                                                                                                        key={`${index}-${triggerIndex}`}
                                                                                                        label={triggerField.label}
                                                                                                        value={selectedOption || null}
                                                                                                        options={processedOptions}
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const updatedCustomFields = [...this.state.customFields];
                                                                                                            if (!updatedCustomFields[index].nestedValues) {
                                                                                                                updatedCustomFields[index].nestedValues = {};
                                                                                                            }
                                                                                                            updatedCustomFields[index].nestedValues[triggerField.id] = selectedOption ? selectedOption.value : '';
                                                                                                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                        }}
                                                                                                    />
                                                                                                );
                                                                                            } else {
                                                                                                return (
                                                                                                    <InputField
                                                                                                        key={`${index}-${triggerIndex}`}
                                                                                                        label={triggerField.label}
                                                                                                        value={nestedValue}
                                                                                                        onChange={(e) => {
                                                                                                            const updatedCustomFields = [...this.state.customFields];
                                                                                                            if (!updatedCustomFields[index].nestedValues) {
                                                                                                                updatedCustomFields[index].nestedValues = {};
                                                                                                            }
                                                                                                            updatedCustomFields[index].nestedValues[triggerField.id] = e.target.value;
                                                                                                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                        }}
                                                                                                    />
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </div>
                                                                                );
                                                                            } else if (field.type === 'sfcontactsearch') {
                                                                                const sfIndex = sfContactSearchIndices.indexOf(index);
                                                                                if (sfIndex >= visibleSfContactSearchCount) return null;

                                                                                const isFirstSfContact = sfIndex === 0;
                                                                                const isLastVisible = sfIndex === visibleSfContactSearchCount - 1;
                                                                                const canRemove = isLastVisible && sfIndex > 0;
                                                                                const canAddMore = visibleSfContactSearchCount < sfContactSearchIndices.length;

                                                                                const fieldContent = (
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className="w-100" style={{ position: 'relative' }}>
                                                                                            <InputField
                                                                                                label={field.label}
                                                                                                required={field.required}
                                                                                                value={this.state.contactSearchValues[index] || ''}
                                                                                                onChange={(e) => this.triggerContactSearch(e.target.value, index)}
                                                                                            />
                                                                                            {!this.state.contactSearching[index] && (
                                                                                                <div style={{ position: 'absolute', right: '10px', top: '28px', color: '#999', fontSize: '20px' }}>
                                                                                                    <i className="las la-search"></i>
                                                                                                </div>
                                                                                            )}
                                                                                            {this.state.contactSearching[index] && (
                                                                                                <div style={{ position: 'absolute', right: '10px', top: '35px', color: '#999' }}>
                                                                                                    <i className="las la-spinner la-spin"></i>
                                                                                                </div>
                                                                                            )}
                                                                                            {this.state.selectedContacts[index] && (
                                                                                                <div style={{ position: 'absolute', right: '35px', top: '35px', cursor: 'pointer' }} onClick={() => {
                                                                                                    this.setState(prevState => ({
                                                                                                        selectedContacts: {
                                                                                                            ...prevState.selectedContacts,
                                                                                                            [index]: null
                                                                                                        },
                                                                                                        contactSearchValues: {
                                                                                                            ...prevState.contactSearchValues,
                                                                                                            [index]: ''
                                                                                                        },
                                                                                                        contactSearchResults: {
                                                                                                            ...prevState.contactSearchResults,
                                                                                                            [index]: []
                                                                                                        }
                                                                                                    }));
                                                                                                    const updatedCustomFields = [...this.state.customFields];
                                                                                                    updatedCustomFields[index].value = '';
                                                                                                    updatedCustomFields[index].displayValue = '';
                                                                                                    this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                }}>
                                                                                                    <i className="las la-times"></i>
                                                                                                </div>
                                                                                            )}
                                                                                            {(this.state.contactSearchResults[index] || []).length > 0 && (
                                                                                                <div style={{
                                                                                                    position: 'absolute',
                                                                                                    top: '100%',
                                                                                                    left: 0,
                                                                                                    right: 0,
                                                                                                    background: 'white',
                                                                                                    border: '1px solid #ccc',
                                                                                                    borderRadius: '4px',
                                                                                                    maxHeight: '200px',
                                                                                                    overflowY: 'auto',
                                                                                                    zIndex: 1000,
                                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                                                }}>
                                                                                                    {(this.state.contactSearchResults[index] || []).map((contact, j) => (
                                                                                                        <div
                                                                                                            key={j}
                                                                                                            style={{
                                                                                                                padding: '10px',
                                                                                                                cursor: 'pointer',
                                                                                                                borderBottom: j < (this.state.contactSearchResults[index] || []).length - 1 ? '1px solid #eee' : 'none'
                                                                                                            }}
                                                                                                            onClick={() => {
                                                                                                                const updatedCustomFields = [...this.state.customFields];
                                                                                                                //updatedCustomFields[index].value = (contact.FirstName || '') + ' ' + (contact.LastName || '');
                                                                                                                updatedCustomFields[index].value = contact.Id;
                                                                                                                updatedCustomFields[index].displayValue = (contact.FirstName || '') + ' ' + (contact.LastName || '');

                                                                                                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                                this.selectContact(contact, index)
                                                                                                            }}
                                                                                                        >
                                                                                                            <div style={{ fontWeight: 'bold' }}>
                                                                                                                {contact.FirstName || ''} {contact.LastName || ''}
                                                                                                            </div>
                                                                                                            <div style={{ fontSize: '12px', color: '#666' }}>
                                                                                                                {contact.Email}
                                                                                                            </div>
                                                                                                            <div style={{ fontSize: '12px', color: '#666' }}>
                                                                                                                {contact.MailingCity ? `${contact.MailingCity}${contact.MailingState ? ', ' : ''}` : ''}{contact.MailingState}{contact.MailingPostalCode ? ` ${contact.MailingPostalCode}` : ''}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        {canRemove && (
                                                                                            <button
                                                                                                className="neu ml-10 "
                                                                                                style={{ marginTop: '9px' }}
                                                                                                onClick={() => {
                                                                                                    // Clear data for this field
                                                                                                    this.setState(prevState => ({
                                                                                                        selectedContacts: {
                                                                                                            ...prevState.selectedContacts,
                                                                                                            [index]: null
                                                                                                        },
                                                                                                        contactSearchValues: {
                                                                                                            ...prevState.contactSearchValues,
                                                                                                            [index]: ''
                                                                                                        },
                                                                                                        contactSearchResults: {
                                                                                                            ...prevState.contactSearchResults,
                                                                                                            [index]: []
                                                                                                        },
                                                                                                        visibleSfContactSearches: sfIndex
                                                                                                    }));
                                                                                                    const updatedCustomFields = [...this.state.customFields];
                                                                                                    updatedCustomFields[index].value = '';
                                                                                                    updatedCustomFields[index].displayValue = '';
                                                                                                    this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                }}
                                                                                            >
                                                                                                <i className="las la-trash"></i>
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                );

                                                                                if (isLastVisible && canAddMore) {
                                                                                    return (
                                                                                        <>
                                                                                            {fieldContent}
                                                                                            <button
                                                                                                className="neu ml-a mb-20"
                                                                                                onClick={() => this.setState({ visibleSfContactSearches: (this.state.visibleSfContactSearches || 1) + 1 })}
                                                                                            >
                                                                                                Add Another Contact
                                                                                            </button>
                                                                                        </>
                                                                                    );
                                                                                } else {
                                                                                    return fieldContent;
                                                                                }


                                                                            } else if (field.type === 'sfaccountsearch') {
                                                                                return (
                                                                                    <div className="w-100" style={{ position: 'relative' }}>
                                                                                        <InputField
                                                                                            label={field.label}
                                                                                            required={field.required}
                                                                                            value={this.state.accountSearchValues[index] || ''}
                                                                                            onChange={(e) => this.triggerAccountSearch(e.target.value, index)}
                                                                                        />
                                                                                        {!this.state.accountSearching[index] && (
                                                                                            <div style={{ position: 'absolute', right: '10px', top: '28px', color: '#999', fontSize: '20px' }}>
                                                                                                <i className="las la-search"></i>
                                                                                            </div>
                                                                                        )}
                                                                                        {this.state.accountSearching[index] && (
                                                                                            <div style={{ position: 'absolute', right: '10px', top: '35px', color: '#999' }}>
                                                                                                <i className="las la-spinner la-spin"></i>
                                                                                            </div>
                                                                                        )}
                                                                                        {this.state.selectedAccounts[index] && (
                                                                                            <div style={{ position: 'absolute', right: '35px', top: '35px', cursor: 'pointer' }} onClick={() => {
                                                                                                this.setState(prevState => ({
                                                                                                    selectedAccounts: {
                                                                                                        ...prevState.selectedAccounts,
                                                                                                        [index]: null
                                                                                                    },
                                                                                                    accountSearchValues: {
                                                                                                        ...prevState.accountSearchValues,
                                                                                                        [index]: ''
                                                                                                    },
                                                                                                    accountSearchResults: {
                                                                                                        ...prevState.accountSearchResults,
                                                                                                        [index]: []
                                                                                                    }
                                                                                                }));
                                                                                                const updatedCustomFields = [...this.state.customFields];
                                                                                                updatedCustomFields[index].value = '';
                                                                                                updatedCustomFields[index].displayValue = '';
                                                                                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                            }}>
                                                                                                <i className="las la-times"></i>
                                                                                            </div>
                                                                                        )}
                                                                                        {(this.state.accountSearchResults[index] || []).length > 0 && (
                                                                                            <div style={{
                                                                                                position: 'absolute',
                                                                                                top: '100%',
                                                                                                left: 0,
                                                                                                right: 0,
                                                                                                background: 'white',
                                                                                                border: '1px solid #ccc',
                                                                                                borderRadius: '4px',
                                                                                                maxHeight: '200px',
                                                                                                overflowY: 'auto',
                                                                                                zIndex: 1000,
                                                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                                            }}>
                                                                                                {(this.state.accountSearchResults[index] || []).map((account, i) => (
                                                                                                    <div
                                                                                                        key={i}
                                                                                                        style={{
                                                                                                            padding: '10px',
                                                                                                            cursor: 'pointer',
                                                                                                            borderBottom: i < (this.state.accountSearchResults[index] || []).length - 1 ? '1px solid #eee' : 'none'
                                                                                                        }}
                                                                                                        onClick={() => {
                                                                                                            const updatedCustomFields = [...this.state.customFields];
                                                                                                            updatedCustomFields[index].value = account.Id;
                                                                                                            updatedCustomFields[index].displayValue = account.Name;

                                                                                                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                            this.selectAccount(account, index)
                                                                                                        }}
                                                                                                    >
                                                                                                        <div style={{ fontWeight: 'bold' }}>{account.Name}</div>
                                                                                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                                                                                            {account.BillingCity ? `${account.BillingCity}${account.BillingState ? ', ' : ''}` : ''}{account.BillingState}{account.BillingPostalCode ? ` ${account.BillingPostalCode}` : ''}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            } else if (field.type === 'multiSelectPicklist') {
                                                                                return (
                                                                                    <div key={index} style={{ marginBottom: '12px' }}>
                                                                                        <div className="formFieldLabel">{field.label || `Field ${index + 1}`}{field.required ? '*' : ''}</div>
                                                                                        {field.options && field.options.map((option, optIndex) => {
                                                                                            const optionValue = (option.value || option.label).trim();
                                                                                            const selectedValues = field.value ? field.value.split(';').map(v => v.trim()).filter(v => v) : [];
                                                                                            const isChecked = selectedValues.includes(optionValue);

                                                                                            return (
                                                                                                <div key={optIndex} style={{ marginBottom: '8px' }}>
                                                                                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={isChecked}
                                                                                                            onChange={(e) => {
                                                                                                                const updatedCustomFields = [...this.state.customFields];
                                                                                                                let currentValues = updatedCustomFields[index].value
                                                                                                                    ? updatedCustomFields[index].value.split(';').map(v => v.trim()).filter(v => v)
                                                                                                                    : [];

                                                                                                                if (e.target.checked) {
                                                                                                                    currentValues.push(optionValue);
                                                                                                                } else {
                                                                                                                    currentValues = currentValues.filter(v => v !== optionValue);
                                                                                                                }

                                                                                                                updatedCustomFields[index].value = currentValues.join(';');
                                                                                                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                                            }}
                                                                                                            style={{ marginRight: '8px' }}
                                                                                                        />
                                                                                                        <span>{option.label}</span>
                                                                                                    </label>
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                );

                                                                            } else {
                                                                                return (
                                                                                    <InputField
                                                                                        key={index}
                                                                                        label={field.label || `Field ${index + 1}`}
                                                                                        required={field.required}
                                                                                        value={field.value}
                                                                                        onChange={(e) => {
                                                                                            const updatedCustomFields = [...this.state.customFields];
                                                                                            updatedCustomFields[index].value = e.target.value;
                                                                                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                                                                        }}
                                                                                    />
                                                                                );
                                                                            }
                                                                        })}
                                                                    </>
                                                                );
                                                            })()}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div >
                    );
                }}
            />
        );
    }
}

export default AddEventModal;
